<template>
  <section v-loading="loading">
    <div class="downloadButtonAction">
      <div class="inside">
        <el-button @click="downloadReport" :loading="downloadLoading"
          >DOWNLOAD
          <el-icon><Bottom /></el-icon>
        </el-button>
      </div>
    </div>
    <iframe :src="reportUrl" width="100%" :height="getScreenHeight"></iframe>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [UserPermissionsHelper],
  computed: {
    ...mapGetters("orders", [
      "getReport",
      "getDownloadReportStatus",
      "getCaseInformation",
    ]),
    ...mapGetters("errors", ["getError"]),
    getScreenHeight() {
      let height = window.innerHeight;
      return height;
    },
  },
  mounted() {
    this.fetchReport();
  },
  data() {
    return {
      reportUrl: "",
      loading: false,
      downloadLoading: false,
    };
  },
  methods: {
    async fetchReport() {
      try {
        this.loading = true;
        this.$store.commit("errors/clear", null, { root: true });
        let params = {
          orderId: this.$route.params.order_id,
          download: true,
        };
        await this.$store.dispatch("orders/fetchRequisitionById", params);
        if (this.getReport) {
          this.reportUrl = "data:application/pdf;base64," + this.getReport;
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    async downloadReport() {
      try {
        this.downloadLoading = true;
        let params = {
          download: true,
          orderId: this.$route.params.order_id,
        };
        await this.$store.dispatch("orders/downloadRequisitionForm", params);
        if (this.getDownloadReportStatus) {
          successNotification("Report Downloaded Successfully");
        } else {
          errorNotification("Error in downloading report");
        }
        this.downloadLoading = false;
      } catch (err) {
        this.downloadLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.downloadButtonAction {
  padding: 5px 0;
  background: #dbdde1;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 10;
  .inside {
    max-width: 900px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    button {
      background: #4bb543;
      color: #ffffff;
      padding: 10px 15px;
      height: auto;
      min-height: auto;
      font-weight: 600;
      svg {
        font-weight: 600;
        margin-left: 5px;
      }
    }
  }
}
.reportPreview {
  padding-top: 75px;
}
</style>
